import { useState, useEffect } from "react";
import { useLocation } from "@reach/router";

const Hook = () => {
  const [state, setState] = useState("");
  const location = useLocation();

  useEffect(() => {
    // Bug real: location.pathname.match(...) da null en cualquier ruta sin
    // equipo — Array.from(null) tira, el catch la tragaba SIN llamar
    // setState, así que al navegar de una ruta con equipo a una sin equipo
    // (ej. logout, onboarding) el teamID quedaba pegado al último equipo
    // visitado en vez de resetear a "".
    const match = location.pathname.match(/^\/teams\/[a-zA-Z0-9]*/);
    setState(match ? match[0].replace("/teams/", "teams/") : "");
  }, [location.pathname]);

  return state;
};

export default Hook;
